import React, { useState} from 'react';
import { connect, useIntl, getLocale } from 'umi';
import { Button } from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';

import GameList from './GameList';
import ComponentProxy from './ComponentProxy';
import EditRelatedGame from './EditRelatedGame';

import './RelatedGame.scss';

const KEY_RECENT_GAME_LIST = 'realRecentGameList';
const KEY_FOLLOW_LIST = 'realGameList';

function RelatedGame(props: any) {
  const {
    recentList,
    followList,
    recentAndFollowLoading,
    setGameModalVisible,
    setActiveId,
    menuWidth
  } = props;
  const [editModalVisible, setEditModalVisible] = useState(false);
  const isEN = getLocale() === 'en-US';
  const noDataText = (() => {
    const switchAll = () => setActiveId('all');
    const switchNew = () => setActiveId('new');
    if (isEN) {
      return {
        recent: (
          <span>
            There are no recent viewed games, <br/> please go to
            <span className='nodata-link-text' onClick={switchAll}>&nbsp;ALL Games&nbsp;</span>or
            <span className='nodata-link-text' onClick={switchNew}>&nbsp;New Games&nbsp;</span>
            to find games.
          </span>
        ),
        follow: (
          <span>
            There are no following games,<br /> please go to
            <span className='nodata-link-text' onClick={switchAll}>&nbsp;ALL Games&nbsp;</span>or
            <span className='nodata-link-text' onClick={switchNew}>&nbsp;New Games&nbsp;</span>
            to follow games.
          </span>
        )
      };
    }
    return {
      recent: (
        <span>
            暂无最近查看的游戏，请到
          <span className='nodata-link-text' onClick={switchAll}>&nbsp;所有游戏&nbsp;</span>或
          <span className='nodata-link-text' onClick={switchNew}>&nbsp;最新上线&nbsp;</span>
            查找游戏。
        </span>
      ),
      follow: (
        <span>
            暂无关注的游戏，请到
          <span className='nodata-link-text' onClick={switchAll}>&nbsp;所有游戏&nbsp;</span>或
          <span className='nodata-link-text' onClick={switchNew}>&nbsp;最新上线&nbsp;</span>
            关注游戏。
        </span>
      )
    };
    
  })();

  const intl = useIntl();
  const GAME_LIST_MAP_INFO: any = {
    [KEY_RECENT_GAME_LIST]: {
      name: intl.formatMessage({id: 'game_selector_recent_title'})
    },
    [KEY_FOLLOW_LIST]: {
      name: intl.formatMessage({id: 'game_selector_follow_title'})
    }
  };


  
  return (
    <>
      <div className='drawer-all'>
        <div className='drawer-title-flex drawer-title-flex-follow' >
          <div className='drawer-title-text'>{GAME_LIST_MAP_INFO[KEY_RECENT_GAME_LIST]?.name}</div>
        </div>
        <ComponentProxy
          loading={recentAndFollowLoading}
          noData={recentList?.length === 0}
          noDataText={noDataText.recent}
          componentRender={() => (
            <GameList
              type='recentView'
              list={recentList}
              setGameModalVisible={setGameModalVisible}
              menuWidth={menuWidth}
            />
          )}
        />
        
        <div className='drawer-title-flex drawer-title-flex-follow' >
          <div className='drawer-title-text'>{GAME_LIST_MAP_INFO[KEY_FOLLOW_LIST]?.name}&nbsp;{`(${followList?.length || 0})`}</div>
          <Button type="weak" onClick={()=>{setEditModalVisible(true)}}  className='exit-btn ns-btn--iconBorder'>
            <SvgIcon className='exit-btn-icon' type="pencil-m"/>{intl.formatMessage({id: 'game_selector_edit_btn'})}
          </Button>
        </div>
        <ComponentProxy
          loading={recentAndFollowLoading}
          noData={followList?.length === 0}
          noDataText={noDataText.follow}
          componentRender={() => (
            <GameList
              type='following'
              list={followList}
              setGameModalVisible={setGameModalVisible}
              menuWidth={menuWidth}
            />
          )}
        />
      </div>
      <EditRelatedGame
        key={editModalVisible}
        visible={editModalVisible}
        followList={followList}
        close={()=>{setEditModalVisible(false)}}
      />
    </>
  );
};

export default connect((state: any) => {
  const { loading } = state;
  return {
    recentAndFollowLoading: loading.effects['dashboard/getRecentAndFollowViewd'],
  };
})(RelatedGame);